
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageSquarePlus, Bug } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const FeedbackCard: React.FC = () => {
  const navigate = useNavigate();
  
  const handleFeedbackClick = () => {
    navigate('/share-feedback');
  };

  return (
    <Card>
      <CardHeader className="bg-blue-50/50 border-b border-blue-100 pb-4">
        <CardTitle className="flex items-center gap-2 text-blue-700">
          <MessageSquarePlus className="h-5 w-5" />
          Share Your Feedback
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <Bug className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" />
            <div>
              <h3 className="font-medium text-gray-900 mb-1">Found a bug or have suggestions?</h3>
              <p className="text-sm text-muted-foreground mb-4">
                Help us improve Forkast by sharing your feedback, reporting bugs, or suggesting new features. 
                Your input helps make the app better for everyone!
              </p>
            </div>
          </div>
          
          <Button 
            onClick={handleFeedbackClick}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          >
            <MessageSquarePlus className="h-4 w-4 mr-2" />
            Share Feedback & Report Bugs
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
